import { createReducer, on, Action } from '@ngrx/store';
import { createEntityAdapter } from "@ngrx/entity"
import { EntityState } from "@ngrx/entity"
import { InvoiceUpload } from '@invoice-upload/models/invoice-upload';
import * as invoiceUploadActions from '../actions/invoice-upload.actions';


export class InvoiceUploadInstance {
  id: string;             // widget config id
  invoices: InvoiceUpload[];
  error: string;
  loading: boolean;
}

export const InvoiceUploadWidgetAdapter = createEntityAdapter<InvoiceUploadInstance>();

export interface State extends EntityState<InvoiceUploadInstance> {
}

export const initialState: State = InvoiceUploadWidgetAdapter.getInitialState();

const invoiceUploadReducer = createReducer(
  initialState,
  on(invoiceUploadActions.load, (state, { widgetConfigurationId }) => {
    return InvoiceUploadWidgetAdapter.addOne({
        id: widgetConfigurationId.toString(),
        invoices: undefined,
        error: undefined,
        loading: undefined
      },
      state);

  }),
  on(invoiceUploadActions.loadComplete, (state, { widgetConfigurationId, invoices }) => {
    return InvoiceUploadWidgetAdapter.updateOne({
      id: widgetConfigurationId.toString(), changes: {
        id: widgetConfigurationId.toString(),
        invoices: invoices,
        error: undefined,
        loading: undefined
      }
    }, state);
  })
);

export function reducer(state: State | undefined, action: Action) {
    return invoiceUploadReducer(state, action);
}
